var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center mb-2"},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"bg-purple-500 p-5 text-white rounded-lg font-light"},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._m(0),_vm._v(". ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('strong',{staticClass:"font-bold"},[_c('a',{attrs:{"href":"/administration/membership"}},[_vm._v("Mi Membresía")])])
}]

export { render, staticRenderFns }